export enum FakeLocalizationLanguage {
  EN = 'en',
  AR = 'ar',
}
